import { Chip } from "common";
import { Flex, SmallTile } from "lqx-react";
import * as React from "react";
import { PaymentRaLandingSummary } from "../../api/payments";
import { WidgetSmallLoading } from "../../common";
import { PendingUnreconciledPayments } from "./unreconciled-payments";
import { PendingUnresolvedPayments } from "./unresolved-payments";
import { PendingUnresolvedRas } from "./unresolved-ras";

export const TodoTiles = ({ $category, model }: { $category, model: PaymentRaLandingSummary }) =>
    <>
        <SmallTile
            color="red"
            $selected={$category.equals('unresolved-payments')}
            right={<Chip color="red">{model.isTodoReady ? model.totalUnresolvedPayments : <WidgetSmallLoading />}</Chip>}
            footer="Payments without relationships"
        >
            Unresolved payments
        </SmallTile>

        <SmallTile
            color="yellow"
            $selected={$category.equals('unreconciled-payments')}
            right={<Chip color="yellow">{model.isTodoReady ? model.totalUnreconciledArPayments : <WidgetSmallLoading />}</Chip>}
            footer="Payments awaiting matching & reconciliation"
        >
            Unreconciled AR payments
        </SmallTile>

        <SmallTile
            color="red"
            $selected={$category.equals('unresolved-ras')}
            right={<Chip color="red">{model.isTodoReady ? model.totalUnresolvedRAs : <WidgetSmallLoading />}</Chip>}
            footer="Remittance advices without relationship"
        >
            Unresolved RAs
        </SmallTile>
    </>

export const TodoDetails = ({ category, model }: { category: string, model: PaymentRaLandingSummary }) =>
    category === 'unresolved-payments' ?
        <PendingUnresolvedPayments payments={model.unresolvedPayments} />
        :
        category === 'unreconciled-payments' ?
            <PendingUnreconciledPayments payments={model.unreconciledArPayments} />
            :
            category === 'unresolved-ras' ?
                <PendingUnresolvedRas ras={model.unresolvedRAs} />
                :
                <Flex center>
                    <h2>Select the category on the left</h2>
                </Flex>
